module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    staticStyle: {
      "padding-left": "50px"
    }
  }, [_c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "the-north-sea"
    }
  }, [_c('div', {
    staticClass: "section level4",
    attrs: {
      "id": "part-2-lowlands"
    }
  }, [_c('div', {
    staticClass: "section level5",
    attrs: {
      "id": "groningen-the-netherlands-19301949"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "width": "550px",
      "padding-top": "20px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("The top drawer of the chest held the bibles and hymnbooks that we carried as status symbols to and from the church.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("On Wednesday afternoons I learned how to make things from wood, and on Saturday afternoons how to work with clay. In the clay class, I soon migrated to the small group that did modelling. I made an elephant, which I knew how to do because we had a set of three elephants at home, carved in Bali from a rare tropical wood.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("In the late 1930s, three of my uncles lived with their families in what was then named the Dutch East Indies. Two were in Java: one was a district judge and the other a minister of the Reformed Church in Jogjakarta. The third uncle, the youngest, was a mathematician who applied his skills to acoustic oil exploration for Shell. He was stationed in Balikpapan, Borneo. Often one or the other family would be on leave in the Netherlands, and would stay at our place or in a house nearby. From the exotic places where they lived, they brought fascinating presents: carved krisses from Java, artwork from Bali, and beautifully woven cloth from the outer islands.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("At school we learned a great deal about Indonesia, we knew about the many islands, the various people and their languages, their agriculture, their ways of building, their art. We all knew a smattering of Bahasa Indonesia, and used some Malay words in day-to-day conversation. When the uncle from Jogjakarta came, he brought with him not only his family but also two Javanese servants; they had wanted to see Holland. The two women crouched on the floor, shivering but with bare feet. I could not understand why they did not put on socks and shoes.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("As a present to my parents, the uncle brought a set of a father, a mother, and a baby elephant. On Sundays, when we sat in the sitting room drinking coffee after church, I would sit down with one of the elephants, exploring and tracing the beautifully carved shapes with my fingers. I had also seen live elephants at a zoo in Drenthe, so I had no trouble modelling the elephant in clay; it just came out my hands. When the teacher saw what I had made he stopped, looked at it, and called somebody else. This person looked, studied the clay beast and in turn went away to call somebody else. The man he came back with was thin and had piercing eyes. He looked first at the elephant from all sides, and then at me. Finally he spoke and asked rather severely if I had studied anatomy. I bent my head in shame and with tears in my eyes managed to blurt out that I did not know what that was. He shook his head and went away.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("Van Dulmen was much easier; I could just talk to him. There were other children of my age, we would accompany him, carry his easel, canvas, paints, brushes and things and go to the banks of the River Aa to swim. The children would strip and dive in the river, van Dulmen would paint the lush green meadows, speckled with wild flowers, and the bend of the river in which the water reflected the clear summer sky. Sometimes he would populate this")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b62996c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0029.vue
// module id = 147
// module chunks = 0